import { siteData } from "@/store/siteData";

export default function HpServiceBanner() {
  const data = siteData.getHpBanner();
  const badgeLines = data.badgeText.split(" ");

  return (
    <section data-edit="hpbanner" className="bg-surface py-20">
      <div className="container-x">
        <div className="grid overflow-hidden rounded-3xl border border-line bg-white shadow-card lg:grid-cols-2">
          {/* Left: content */}
          <div className="p-8 md:p-10 lg:p-12">
            <div className="flex items-center gap-3">
              <span className="grid h-12 w-12 place-items-center rounded-full bg-brand/10">
                <img src="/logos/hp.svg" alt="HP" className="h-7 w-7" />
              </span>
              <h2 className="text-2xl font-bold text-ink sm:text-3xl">
                {data.title}
              </h2>
            </div>
            <p className="mt-4 max-w-md text-muted">
              {data.subtitle}
            </p>

            <div className="mt-8 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2">
              {data.features.map((f) => (
                <div key={f.id} className="flex items-start gap-3">
                  <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-brand/10 text-brand">
                    <i className={`${f.icon} text-xl`}></i>
                  </span>
                  <span>
                    <span className="block text-base font-semibold text-ink">
                      {f.title}
                    </span>
                    <span className="block text-sm text-muted">{f.sub}</span>
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: image + partner badge */}
          <div className="relative min-h-[300px] overflow-hidden">
            <img
              src={data.imageUrl}
              alt="Sunucu odası"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div
              className="absolute inset-0"
              style={{
                background:
                  "linear-gradient(130deg, rgba(8,19,46,0.92) 0%, rgba(11,63,168,0.78) 100%)",
              }}
            />
            <div className="relative grid h-full place-items-center p-10">
              <div className="flex flex-col items-center gap-4 rounded-2xl border border-white/20 bg-white/10 px-8 py-7 text-center backdrop-blur">
                <span className="grid h-20 w-20 place-items-center rounded-full bg-white shadow-soft">
                  <img src="/logos/hp.svg" alt="HP" className="h-11 w-11" />
                </span>
                <span className="text-sm font-bold uppercase tracking-[0.25em] text-white">
                  {badgeLines.map((w, i) => (
                    <span key={i}>{w}{i < badgeLines.length - 1 && <br />}</span>
                  ))}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
